import { useNitroStore } from "./Store";

const NitroStateManagement = () => {
  const [setHideLocationPins] = useNitroStore((state) => [
    state.setHideLocationPins,
  ]);

  useNitroStore.subscribe((currentState, previousState) => {
    if (
      currentState.showInsightsPanel === previousState.showInsightsPanel &&
      currentState.showAddLocationPanel ===
        previousState.showAddLocationPanel &&
      currentState.insightsPanelTab === previousState.insightsPanelTab &&
      currentState.insightOverviewTab === previousState.insightOverviewTab &&
      currentState.insightsEditing === previousState.insightsEditing &&
      currentState.showCompetitiveAnalysisModal ===
        previousState.showCompetitiveAnalysisModal
    ) {
      return;
    }

    if (currentState.showAddLocationPanel) {
      if (!currentState.hideLocationPins) {
        setHideLocationPins(true);
      }
    } else if (
      currentState.showInsightsPanel &&
      currentState.insightsPanelTab === "Overview" &&
      currentState.insightOverviewTab === "Facility" &&
      currentState.insightsEditing === "Facility"
    ) {
      if (!currentState.hideLocationPins) {
        setHideLocationPins(true);
      }
    } else if (currentState.showCompetitiveAnalysisModal) {
      if (!currentState.hideLocationPins) {
        setHideLocationPins(true);
      }
    } else if (currentState.hideLocationPins) {
      console.info("Show location pins");
      setHideLocationPins(false);
    }
  });

  return null;
};

export default NitroStateManagement;
